import { AreaChart, Users } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import React from "react";
import { ModuleBlock } from "../../../ui/Block";
import type { InfoRowItemProps } from "../../../ui/InfoRow";
import type TrackerModuleModel from "../TrackerModuleModel";

export const TrackerModuleBlockUI = observer(
  ({ module }: { module: TrackerModuleModel }) => {
    const infoRowItems = React.useMemo<InfoRowItemProps[]>(
      () => [
        {
          text: `${module.data.snapshot.totalStatsCount ?? 0} entries`,
          icon: AreaChart,
        },
        {
          text: `${module.data.snapshot.totalParticipants ?? 0} participants`,
          icon: Users,
        },
      ],
      [module.data.snapshot],
    );

    return (
      <ModuleBlock
        module={module}
        infoRowItems={infoRowItems}
        doneText={"This is completed"}
      />
    );
  },
);
